export const CSS_CUSTOM_PROPERTIES_COLORS = [
  'color-white',
  'color-soft-black',
  'color-neutral-70',
  'color-brand-violet',
  'color-information-dark',
  'color-sembo-purple',
  'color-brand-lilac',
  'color-soft-black',
  'color-neutral-70',
  'color-neutral-60',
  'color-neutral-50',
  'color-neutral-40',
  'color-neutral-30',
  'color-neutral-20',
  'color-neutral-10',
  'color-brand-coral',
  'color-brand-summer',
  'color-brand-jungle',
  'color-overlay',
] as const;

export type CssCustomPropertyColor =
  (typeof CSS_CUSTOM_PROPERTIES_COLORS)[number];

export const CSS_CUSTOM_PROPERTIES_SPACING = [
  'spacing-2',
  'spacing-4',
  'spacing-8',
  'spacing-12',
  'spacing-16',
  'spacing-20',
  'spacing-24',
  'spacing-32',
  'spacing-40',
  'spacing-48',
  'spacing-64',
  'spacing-80',
  'spacing-96',
] as const;

export type CssCustomPropertySpacing =
  (typeof CSS_CUSTOM_PROPERTIES_SPACING)[number];

export type CssCustomPropertyBorderRadius =
  | 'border-radius-4'
  | 'border-radius-8'
  | 'border-radius-12'
  | 'border-radius-20'
  | 'border-radius-30';

export type CssCustomPropertyFont =
  | 'font-link-s-light'
  | 'font-link-l-light'
  | 'font-body-s-bold'
  | 'font-body-s-light'
  | 'font-body-m-bold'
  | 'font-body-m-light'
  | 'font-body-l-bold'
  | 'font-body-l-light'
  | 'font-label-s-bold'
  | 'font-label-s-light'
  | 'font-label-m-bold'
  | 'font-label-m-light'
  | 'font-label-l-bold'
  | 'font-label-l-light'
  | 'font-label-xl-bold'
  | 'font-label-xl-light'
  | 'font-heading-6'
  | 'font-heading-5'
  | 'font-heading-4'
  | 'font-heading-3'
  | 'font-heading-2'
  | 'font-heading-1'
  | 'font-title-label-l';

export const CSS_CUSTOM_PROPERTIES_FONT_SIZE = [
  'font-size-s', // 12px
  'font-size-m', // 14px
  'font-size-l', // 16px
  'font-size-xl', // 18px
  'font-size-h5', // 20px
  'font-size-h4', // 24px
  'font-size-h3', // 28px
  'font-size-h2', // 32px
  'font-size-h1', // 44px
] as const;

export type CssCustomPropertyFontSize =
  (typeof CSS_CUSTOM_PROPERTIES_FONT_SIZE)[number];

export type CssCustomPropertyZIndex =
  | 'panel-first-level-z-index'
  | 'modal-overlay-z-index'
  | 'modal-z-index';

export type CustomPropertyName =
  | CssCustomPropertyColor
  | CssCustomPropertySpacing
  | CssCustomPropertyBorderRadius
  | CssCustomPropertyFont
  | CssCustomPropertyFontSize
  | CssCustomPropertyZIndex;

export function getCssCustomPropertyValue(
  propertyName: CustomPropertyName
): string {
  return getComputedStyle(document.documentElement).getPropertyValue(
    `--${propertyName}`
  );
}

export function getStringStyles(
  color: CssCustomPropertyColor | undefined,
  getter: (variableName: CustomPropertyName) => string
): { color: string } {
  return {
    color: color ? getter(color) : '',
  };
}
